export var generateFilterStateKey = function generateFilterStateKey(filters) {
  return Object.entries(filters) // loop through the filters
  .sort(function (a, b) {
    return a[0].localeCompare(b[0]);
  }) // sort the categories into alphabetical order
  .flat() // flatten the category and value
  .join('_');
}; // join as a string